import React from 'react';
function PopoverTarget(_a) {
    var children = _a.children, id = _a.id, className = _a.className;
    return (React.createElement("div", { id: id, className: className }, children));
}
PopoverTarget.displayName = 'PopoverTarget';
export default PopoverTarget;
